export type NodeRipplePaint = {
  radius: number
  opacity: number
}

export type NodeRippleOptions = {
  durationMs?: number
  minRadius?: number
  maxRadius?: number
  maxOpacity?: number
  phaseOffsetMs?: number
  attackFraction?: number
}

export const NODE_RIPPLE_DURATION_MS = 4800
export const NODE_RIPPLE_MIN_RADIUS = 8
export const NODE_RIPPLE_MAX_RADIUS = 24
export const NODE_RIPPLE_MAX_OPACITY = 0.55
export const NODE_RIPPLE_ATTACK_FRACTION = 0.1

/** Expanding ring paint for one pulse cycle (ease-out radius, soft-attack ease-out fade). */
export function nodeRippleFrame(elapsedMs: number, options: NodeRippleOptions = {}): NodeRipplePaint {
  const durationMs = options.durationMs ?? NODE_RIPPLE_DURATION_MS
  const minRadius = options.minRadius ?? NODE_RIPPLE_MIN_RADIUS
  const maxRadius = options.maxRadius ?? NODE_RIPPLE_MAX_RADIUS
  const maxOpacity = options.maxOpacity ?? NODE_RIPPLE_MAX_OPACITY
  const phaseOffsetMs = options.phaseOffsetMs ?? 0
  const attackFraction = options.attackFraction ?? NODE_RIPPLE_ATTACK_FRACTION
  const t = ((((elapsedMs + phaseOffsetMs) % durationMs) + durationMs) % durationMs) / durationMs
  const eased = 1 - (1 - t) * (1 - t)
  const attack = attackFraction <= 0 ? 1 : Math.min(1, t / attackFraction)
  const fade = (1 - t) * (1 - t)
  return {
    radius: minRadius + (maxRadius - minRadius) * eased,
    opacity: maxOpacity * attack * fade,
  }
}
